'use strict'

$('.p-homeFeature__moreButton').click(function(){
	$(this).addClass('is-open')
	$('.p-homeFeature__list').addClass('is-open')
})
